module.exports = __webpack_public_path__ + "img/logo_circle_invertito.212e3a98.png";